import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const SchedulingSettings: React.FC = () => {

    const settings: SettingsSettingType[] = [
        {
            title: 'scheduling.settings.displayed_times_title',
            scope: 'division',
            explanationText: 'scheduling.settings.displayed_times_explanation',
            fields: [
                {
                    type: 'time',
                    name: 'scheduling_display_start_time',
                    group: 'field-row',
                    width: 'auto'
                },
                {
                    type: 'time',
                    name: 'scheduling_display_end_time',
                    group: 'field-row',
                    width: 'auto'
                }
            ]
        },

        // {
        //     title: 'Plan in tijdsblokken',
        //     requiredFeature: 'scheduling_time_blocks',
        //     dependentOn: { fieldName: 'scheduling_default_view', value: ['employee_list', 'employee_timeline'] },
        //     explanationText: 'De mogelijkheid om afspraken in te plannen in tijdsblokken in plaats van op uren, en geef de buitendienst medewerker meer flexibiliteit.',
        //     switchButton: {
        //         enabled: true,
        //         name: 'scheduling_time_blocks',
        //     }
        // },
        {
            title: 'scheduling.settings.default_appointment_status_title',
            scope: 'division',
            fields: [
                {
                    type: 'dropdown',
                    name: 'scheduling_default_appointment_status',
                    allowNoneOption: false,
                    showSearch: false,
                    defaultValue: { value: 'scheduled' },
                    hardcodedOptions: [
                        { value: 'reserved', name: 'scheduling.settings.reserved_option' },
                        { value: 'scheduled', name: 'scheduling.settings.scheduled_option' },
                    ]
                }
            ]
        },
        {
            title: 'scheduling.settings.appointment_text_title',
            scope: 'division',
            explanationText: 'scheduling.settings.appointment_text_explanation',
            fields: [
                {
                    type: 'scheduling-appointment-text',
                    name: 'scheduling_appointment_text',
                }
            ]
        },
        {
            title: 'scheduling.settings.job_inbox_module_title',
            requiredFeature: 'job_inbox',
            explanationText: 'scheduling.settings.job_inbox_module_explanation',
            switchButton: {
                enabled: true,
                name: 'job_inbox',
                featureSwitch: true,
            }
        },
        {
            title: 'scheduling.settings.manual_to_schedule_title',
            scope: 'division',
            subSetting: true,
            explanationText: 'scheduling.settings.manual_to_schedule_explanation',
            switchButton: {
                enabled: true,
                name: 'scheduling_manual_to_schedule_status',
            }
        },
        {
            title: 'scheduling.settings.show_unassigned_row_title',
            scope: 'division',
            explanationText: 'scheduling.settings.show_unassigned_row_explanation',
            switchButton: {
                enabled: true,
                name: 'scheduling_show_unassigned_row',
            }
        },
        {
            title: 'scheduling.settings.show_employee_timetable_title',
            scope: 'division',
            requiredFeature: 'employee_timetable',
            explanationText: 'scheduling.settings.show_employee_timetable_explanation',
            switchButton: {
                enabled: true,
                name: 'scheduling_show_employee_timetable',
            }
        },
        {
            title: 'scheduling.settings.default_whole_day_title',
            scope: 'division',
            requiredFeature: 'employee_timetable',
            explanationText: 'scheduling.settings.default_whole_day_explanation',
            switchButton: {
                enabled: true,
                name: 'scheduling_default_appointment_whole_day',
            }
        },
        {
            title: 'scheduling.settings.worker_pairs_title',
            requiredFeature: 'worker_pairs',
            explanationText: 'scheduling.settings.worker_pairs_explanation',
            switchButton: {
                enabled: true,
                name: 'worker_pairs',
                featureSwitch: true,
            }
        },
        {
            title: 'scheduling.settings.equipment_scheduling_title',
            requiredFeature: 'equipment_scheduling',
            explanationText: 'scheduling.settings.equipment_scheduling_explanation',
            switchButton: {
                enabled: true,
                name: 'equipment_scheduling',
                featureSwitch: true,
            }
        },
        {
            title: 'scheduling.settings.project_planning_title',
            requiredFeature: 'project_planner',
            explanationText: 'scheduling.settings.project_planning_explanation',
            switchButton: {
                enabled: true,
                name: 'project_show_scheduling',
            }
        },
        // {
        //     title: `Beschikbare capaciteit berekenen`,
        //     requiredFeature: 'employee_scheduling',
        //     explanationText: 'Laat het systeem op basis van het reeds geplande werk en het rooster van je medewerkers de nog beschikbare capaciteit per week berekenen. Hierdoor kun je beter vooruit plannen.',
        //     switchButton: {
        //         enabled: true,
        //         name: '',
        //     }
        // },
    ];

    return (
        <SettingsContainer settings={settings} infoText='scheduling.settings.personal_settings_notice' />
    );
};

export default SchedulingSettings;
